import React, { PureComponent } from 'react';
import styles from './index.css';
import { VideoEvents } from './video';
const videoEventsMap = VideoEvents;
/**
 * 视频核心 Core 组件
 */
// @flow
class Core extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            status: 'pause',
        };
        this.bindPause = () => {
            this.pause();
        };
        this.el = React.createRef();
        const { openClient } = this.props;
    }
    load() {
        if (this.el && this.el.current && typeof this.el.current.load === 'function') {
            (() => {
                try {
                    this.el.current.load();
                }
                catch (e) {
                    this.catchError(e);
                }
            })();
        }
    }
    play() {
        const playPromise = this.el && this.el.current && this.el.current.play();
        if (window && this.props.singlePlay) {
            if (window.ifengVideoSinglePlay && window.ifengVideoSinglePlay !== this.bindPause) {
                window.ifengVideoSinglePlay();
            }
            window.ifengVideoSinglePlay = this.bindPause;
        }
        if (playPromise && typeof playPromise.then === 'function') {
            playPromise
                .then(() => {
                // console.log('video start play');
            })
                .catch((e) => {
                this.catchError(e);
            });
        }
    }
    catchError(e) {
        this.props.errorHandle();
        console.error('video error====>', e.message);
    }
    isPaused() {
        return this.el && this.el.current && this.el.current.paused;
    }
    pause() {
        // 安全的暂停
        const playPromise = this.el && this.el.current && this.el.current.play();
        if (playPromise && typeof playPromise.then === 'function') {
            playPromise.then(() => {
                if (this.el && this.el.current) {
                    this.el.current.pause();
                    console.log('安全的暂停');
                }
            });
        }
    }
    pauseAfterLeave() {
        if (this.el && this.el.current && !this.el.current.paused) {
            this.el.current.pause();
        }
    }
    getCurrentTime() {
        if (this.el && this.el.current && this.el.current.currentTime) {
            // console.log('获取当前的时间 ', Math.round(this.el.current.currentTime));
            return Math.round(this.el.current.currentTime);
        }
        return 0;
    }
    setCurrent(sec) {
        if (sec || sec === 0) {
            try {
                if (this.el && this.el.current && this.el.current.currentTime) {
                    this.el.current.currentTime = sec;
                }
            }
            catch (e) {
                console.error(e, 'video is not ready');
            }
        }
    }
    getDuration() {
        if (this.el && this.el.current && this.el.current.duration) {
            return this.el.current.duration;
        }
        return 0;
    }
    getBuffereds() {
        if (this.el && this.el.current && this.el.current.buffered) {
            const buffered = this.el.current.buffered;
            return buffered.length !== 0 ? buffered.end(buffered.length - 1) : 0;
        }
        return 0;
    }
    on(eventName, callback) {
        if (videoEventsMap &&
            videoEventsMap.includes &&
            videoEventsMap.includes(eventName) &&
            this.el &&
            this.el.current) {
            this.el.current.addEventListener(eventName, callback.bind(this));
        }
    }
    off(eventName, callback) {
        if (videoEventsMap &&
            videoEventsMap.includes &&
            videoEventsMap.includes(eventName) &&
            this.el &&
            this.el.current) {
            this.el.current.removeEventListener(eventName, callback.bind(this));
        }
    }
    componentDidMount() {
        if (this.props.openClient === 1) {
            this.pause();
        }
    }
    // componentDidUpdate() {
    //     if (this.props.openClient === 1) {
    //         this.pause()
    //     }
    // }
    render() {
        const { videoConfig, handleVideoClick } = this.props;
        return videoConfig.mobileUrl ? (React.createElement("video", { className: styles.videoCore, id: "player", src: videoConfig.mobileUrl, 
            // preload={isIphone() ? 'meta' : 'auto'}
            preload: "meta", ref: this.el, onClick: handleVideoClick.bind(this), playsInline: true })) : null;
    }
}
export default Core;
